import React, { useEffect, useState } from "react";
import logo2 from "../img/headshot-bw.png";

const Navbar: React.FC = () => {
    const [showNavbar, setShowNavbar] = useState<boolean>(false);

    useEffect(() => {
        const handleScroll = (): void => {
            const navbar = document.querySelector(".navbar-expand-md");
            if (navbar) {
                if (window.scrollY > 0) {
                    setShowNavbar(true);
                    navbar.classList.add("navbar-reduce");
                    navbar.classList.remove("navbar-trans");
                } else {
                    setShowNavbar(false);
                    navbar.classList.add("navbar-trans");
                    navbar.classList.remove("navbar-reduce");
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        const href = e.currentTarget.getAttribute("href");

        if (href) {
            const element = document.querySelector(href);
            const nav = document.querySelector("nav");

            if (element && nav) {
                const navHeight = nav.offsetHeight;
                const elementPosition = element.getBoundingClientRect().top + window.scrollY;

                window.scrollTo({
                    top: elementPosition - navHeight + 5,
                    behavior: "smooth"
                });
            }
        }
    };

    return (
        <nav className="navbar navbar-b navbar-trans navbar-expand-md fixed-top p-0" style={{ height: "80px" }} id="mainNav">
            <div className="container">
                <a className="navbar-brand js-scroll" href="#page-top">
                    {showNavbar && (
                        <img
                            src={logo2}
                            alt="logo"
                            style={{
                                position: "relative",
                                maxHeight: "60px",
                                borderRadius: "0",
                                border: "4px solid #000000",
                                transition: "all 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)",
                                boxShadow: "4px 4px 0px #FF006E",
                                transform: "rotate(-2deg)"
                            }}
                        />
                    )}
                </a>
                {showNavbar && <div>
                    <ul className="navbar-nav ml-auto">
                        <a
                            className="btn btn-outline-light js-scroll px-4 mt-0"
                            href="#contact"
                            role="button"
                            onClick={handleClick}
                        >
                            Contact
                        </a>
                    </ul>
                </div>}
            </div>
        </nav>
    );
};

export default Navbar;
